import { WarningIcon } from "../icons"
import { ISpecialOrderResponse } from "../interfaces/special-order-interfaces"
import { Toasts } from "./toasts"

const el = {
  root: document.querySelector<HTMLDivElement>('#product-special-order'),
  addToCartButtons: document.querySelectorAll<HTMLButtonElement>('.product-layout .add-to-cart-form [type="submit"], .product-bar .add-to-cart-form [type="submit"]'),
  guid: document.querySelector<HTMLInputElement>('.product-layout')?.dataset?.productkey || '',
  productPrices: document.querySelector<HTMLDivElement>('#product-prices'),
  addToCartForms: document.querySelectorAll<HTMLFormElement>('.product-layout .add-to-cart-form, .product-bar .add-to-cart-form'),
  productBarPrice: document.querySelector<HTMLParagraphElement>('.product-bar__price'),
  productSku: document.querySelector<HTMLParagraphElement>('#product-sku'),
}

export const SpecialOrder = {
  init: () => {
    if (!el.root || !el.addToCartForms.length) return
    SpecialOrder.activateSpecialOrderBox()
  },

  activateSpecialOrderBox: () => {
    const inputs = document.querySelectorAll<HTMLInputElement>('#product-special-order .pillar__input')
    inputs.forEach(target => target.addEventListener('change', async (e: Event & { target: HTMLInputElement }) => {
      try {
        const queryParams = Array.from(inputs).filter(x => x.checked).map(x => `${x.name}=${x.value}`)
        queryParams.push(`nodeId=${el.guid}`)

        const response = await fetch(`/api/product/GetCustomOrderPrice?${queryParams.join('&')}`);
        const data: ISpecialOrderResponse = await response.json();
        if (!data) throw Error('')

        SpecialOrder.updateHtml(data)
      } catch (_) {
        Toasts.addToast({
          title: 'Villa kom upp!',
          text: 'Ekki tókst að velja vöruafbrigði',
          icon: WarningIcon(),
        })
      }
    }))
  },

  updateHtml: (data: ISpecialOrderResponse) => {
    if (el.productPrices) el.productPrices.innerHTML = SpecialOrder.generatePricesHtml(data)

    if (el.addToCartButtons.length) {
      el.addToCartButtons.forEach(target => target.disabled = false)
    }

    el.addToCartForms.forEach(target => {
      const customSkuInput = target.querySelector<HTMLInputElement>('[name="customSKU"]')
      if (!customSkuInput) {
        const inputElement = SpecialOrder.createCustomSkuInput(data.VariantCode)
        target.appendChild(inputElement)
        return
      }
      customSkuInput.value = data.VariantCode
    })

    if (el.productSku) el.productSku.innerText = data.VariantCode

    if (!el.productBarPrice) return

    el.productBarPrice.innerText = data.PriceFormatted

    if (data.IsDiscounted) {
      el.productBarPrice.classList.add('text--purple')
    } else {
      el.productBarPrice.classList.remove('text--purple')
    }
  },

  generatePricesHtml: (data: ISpecialOrderResponse): string => {

    if (data.IsDiscounted) {
      return `
        <p class="product-info__price product-info__price--old h-flex-wrap-item">${data.OriginalPriceFormatted}</p>
        <p class="product-info__price product-info__price--discount h-flex-wrap-item">${data.PriceFormatted}</p>
      `
    }

    return `<p class="product-info__price h-flex-wrap-item">${data.PriceFormatted}</p>`
  },

  createCustomSkuInput: (value = '') => {
    const inputElement = document.createElement('input')
    inputElement.setAttribute('type', 'hidden')
    inputElement.setAttribute('name', 'customSKU')
    inputElement.setAttribute('value', value)
    return inputElement
  },

  setButtonLabel: (el: HTMLButtonElement) => {
    const { special = '' } = el.dataset
    if (!special) return
    const textElement = el.querySelector<HTMLSpanElement>('.button__text')
    if (textElement) textElement.innerText = special
  }

}